<main class="s-siteContainer">

  <section id="hero-container" class="c-hero">
    <div class="l-container">

      <div class="l-grid">

        <div class="l-col lg:6 sm:12">
          <div class="c-hero__body">
            <h1 class="c-hero__title" translate>E-MEDIKUS</h1>
            <p class="c-hero__desc" translate>
              Stručne edukacije iz medicine
            </p>
            <div class="c-hero__cta" *ngIf="!user && user !== undefined">
              <a [routerLink]="['/login']" class="c-btn is-primary is-outlined" translate>Prijavite se</a>
              <a [routerLink]="['/registration']" class="c-btn is-primary" translate>Registrirajte se</a>
            </div>
          </div>
        </div>

        <div app-hero-image class="l-col lg:6 sm:12"></div>
      </div>

    </div>
  </section>

  <div class="s-section">
    <div class="l-container">

      <div class="l-grid l-grid--40">

        <div class="l-col lg:3 md:12">

          <div class="c-filter js-collapsible is-open">
            <button class="c-filter__title js-collapsible__toggle" id="ft-1" aria-controls="ft-1" aria-expanded="true"
                    translate>
              Prema bodovima
            </button>
            <div class="c-filter__panel js-collapsible__panel" role="region" id="fp-1" aria-labelledby="ft-1"
                 aria-hidden="false">

              <div class="c-filter__panel_item">
                <div class="c-check">
                  <input type="checkbox" class="e-checkbox" name="f1" id="f1-1"
                         [checked]="isFilterChecked(selectedPoints, 1)"
                         (click)="toggleFilterArray(selectedPoints, 1)" [disabled]="withPointsCount === 0">
                  <label for="f1-1">
                    {{'Bodovani tečajevi' | translate}} <span
                    *ngIf="withPointsCount !== undefined">({{withPointsCount}})</span>
                  </label>
                </div>
              </div>

              <div class="c-filter__panel_item">
                <div class="c-check">
                  <input type="checkbox" class="e-checkbox" name="f1" id="f1-2"
                         [checked]="isFilterChecked(selectedPoints, 0)"
                         (click)="toggleFilterArray(selectedPoints, 0)" [disabled]="withoutPointsCount === 0">
                  <label for="f1-2">
                    {{'Nebodovani tečajevi' | translate}} <span
                    *ngIf="withoutPointsCount !== undefined">({{withoutPointsCount}})</span>
                  </label>
                </div>
              </div>

            </div>
          </div>

          <div class="c-filter js-collapsible is-open">
            <button class="c-filter__title js-collapsible__toggle" id="ft-3" aria-controls="ft-3" aria-expanded="true"
                    translate>
              Tip tečaja
            </button>
            <div class="c-filter__panel js-collapsible__panel" role="region" id="fp-3" aria-labelledby="ft-3"
                 aria-hidden="false">

              <div class="c-filter__panel_item" *ngFor="let category of courseCategories;let i = index">
                <div class="c-check" *ngIf="category.itemCount > 0 && category.subCategories?.length === 0">
                  <input type="checkbox" class="e-checkbox" name="f2" [id]="'f2-' + i"
                         [checked]="isFilterChecked(selectedCategories, category.id)"
                         (click)="toggleFilterArray(selectedCategories, category.id)">
                  <label [for]="'f2-' + i">
                    {{category.name}} <span *ngIf="!!category.itemCount">({{category.itemCount}})</span>
                  </label>
                </div>
              </div>

            </div>
          </div>

          <div class="c-filter js-collapsible is-open">
            <button class="c-filter__title js-collapsible__toggle" id="ft-2" aria-controls="ft-2" aria-expanded="true"
                    translate>
              Područja
            </button>
            <div class="c-filter__panel js-collapsible__panel" role="region" id="fp-2" aria-labelledby="ft-2"
                 aria-hidden="false">

              <div class="c-filter__panel_item" *ngFor="let type of tags;let i = index">
                <div class="c-check" *ngIf="type.itemCount > 0">
                  <input type="checkbox" class="e-checkbox" name="f3" [id]="'f3-' + i"
                         [checked]="isFilterChecked(selectedTypes, type.id)"
                         (click)="toggleFilterArray(selectedTypes, type.id)">
                  <label [for]="'f3-' + i">
                    {{type.name}} <span *ngIf="!!type.itemCount">({{type.itemCount}})</span>
                  </label>
                </div>
              </div>

            </div>
          </div>

        </div>

        <div id="courses-container" class="l-col lg:9 md:12">

          <div class="c-media__placeholder l-grid l-grid--40 is-3:1 is-loading" *ngIf="loading"></div>

          <div class="l-grid l-grid--40" *ngIf="!loading">

            <div class="l-col lg:4 sm:6 xs:12" *ngFor="let course of courses">
              <article app-card class="c-card" [title]="course.title"
                       [imageUrl]="(course.mainImage) | file:'image':'lms':640"
                       [tags]="courseUtil.courseTypes(course)"
                       [infoTags]="courseUtil.courseInfo(course)"
                       [link]="['/courses', course.urlSlug]"
                       [progress]="course.progress"
                       [completed]="course.enrolment?.status === 'COMPLETED'"
                       [disabled]="courseUtil.isCourseDisabledForUser(course, user)">
              </article>
            </div>

            <div app-pagination class="l-col lg:12" *ngIf="totalPages > 1" [currentPage]="selectedPage"
                 [totalPages]="totalPages"></div>

          </div>

        </div>

      </div>

    </div>
  </div>

</main>
